import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import clsx from 'clsx';
const inputClass = 'w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 placeholder:text-gray-400 focus:border-arshe-500 focus:outline-none focus:ring-2 focus:ring-arshe-500/30 disabled:opacity-60 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-100';
export const Label = ({ children }) => (_jsx("label", { className: "mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300", children: children }));
export function Field({ label, error, hint, children }) {
    return (_jsxs("div", { className: "space-y-1", children: [label && _jsx(Label, { children: label }), children, hint && !error && _jsx("p", { className: "text-xs text-gray-500", children: hint }), error && _jsx("p", { className: "text-xs text-red-600", children: error })] }));
}
export const Input = forwardRef(function Input({ className, ...rest }, ref) {
    return _jsx("input", { ref: ref, className: clsx(inputClass, className), ...rest });
});
export const Select = forwardRef(function Select({ className, children, ...rest }, ref) {
    return _jsx("select", { ref: ref, className: clsx(inputClass, className), ...rest, children: children });
});
export const Textarea = forwardRef(function Textarea({ className, ...rest }, ref) {
    return _jsx("textarea", { ref: ref, className: clsx(inputClass, 'min-h-[80px]', className), ...rest });
});
